import { Stack, Text } from "@mantine/core";
import { DataResult, EntityClientAction, FakeProgressBar, useExecuteProc, useExportToExcel } from "@mcurros2/microm";
import { useEffect, useState } from "react";
import { Reportes } from "./Reportes";

export const ExportarExcelModal = ({ reportes, onClose }: { reportes: Reportes, onClose: () => void }) => {
    const getReportes = useExecuteProc(reportes, reportes.def.procs.repo_qryReportes);

    const [datos0, setDatos0] = useState<DataResult>();

    const { exportToExcel } = useExportToExcel({
        data: [datos0!],
        dataResultNames: ['Base Reportes']
    });

    useEffect(() => {
        async function fetchData() {
            await getReportes.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.parentKeys.dt_fecha_desde,
                dt_fecha_hasta: reportes.parentKeys.dt_fecha_hasta,
                c_autorizacion_directa_status_id: reportes.parentKeys.c_autorizacion_directa_status_id,
                dt_fecha_realizado_desde: reportes.parentKeys.dt_fecha_realizado_desde,
                dt_fecha_realizado_hasta: reportes.parentKeys.dt_fecha_realizado_hasta,
            });
        }
        fetchData();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.parentKeys.dt_fecha_desde,
        reportes.parentKeys.dt_fecha_hasta,
        reportes.parentKeys.c_autorizacion_directa_status_id,
        reportes.parentKeys.dt_fecha_realizado_desde,
        reportes.parentKeys.dt_fecha_realizado_hasta
    ]);

    useEffect(() => {
        if (!getReportes.status.loading && getReportes.status.data) {
            setDatos0(getReportes.status.data[0]);
        }
    }, [getReportes.status]);

    useEffect(() => {
        if (datos0) {
            exportToExcel();
            onClose();
        }
    }, [datos0]);

    return (
        <Stack>
            <Text>Generando archivo...</Text>
            <FakeProgressBar />
        </Stack>
    )
};


export const ACTExportarExcel: EntityClientAction = {
    name: 'ACTExportarExcel',
    label: 'Exportar Excel',
    title: <Text fw={700}>Exportar Excel</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: ['repo_brwBaseReportesDetallada'],
    onClick: async ({ entity, modal, element, onClose }) => {
        const reportes = entity as Reportes;

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Exportar Excel</Text>
            },
            focusOnClosed: element,
            content: <ExportarExcelModal reportes={reportes} onClose={() => modal.close()} />

        });

        return false;
    }
}